module.exports = __webpack_public_path__ + "img/4.8f338c59.png";